import { render, staticRenderFns } from "./TextView.vue?vue&type=template&id=8d004ac2&scoped=true"
import script from "./TextView.vue?vue&type=script&lang=ts"
export * from "./TextView.vue?vue&type=script&lang=ts"
import style0 from "./TextView.vue?vue&type=style&index=0&id=8d004ac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d004ac2",
  null
  
)

export default component.exports